/* assets/src/viewer/pdf/views.js
 * Rende le 3 inquadrature per il PDF (port app.js :3250-3301) e ritorna i dataURL JPEG.
 * Salva/ripristina lo stato camera/renderer. app.js può continuare a usare il suo path
 * (i globals window.renderer/scene/camera/controls restano validi); questa è l'API pulita.
 */
import { Vector3 } from 'three';

export function renderViewsForPdf(viewer) {
  const { renderer, scene, camera, controls } = viewer;
  const canvas = renderer.domElement;
  if (!renderer || !scene || !camera || !canvas) return null;

  let w = 2.8; let d = 2.2; let centerX = 0; let centerY = 1.7; let centerZ = 0; let maxDim = 3;
  const box = viewer.currentSceneBounds;
  if (box && !box.isEmpty()) {
    const s = box.getSize(new Vector3());
    const c = box.getCenter(new Vector3());
    w = s.x; d = s.z; centerX = c.x; centerY = c.y; centerZ = c.z;
    maxDim = Math.max(s.x, s.y, s.z);
  }

  const prevAuto = renderer.autoClear;
  renderer.autoClear = true;
  renderer.setScissorTest(false);
  const cW = canvas.width; const cH = canvas.height;
  const savePos = camera.position.clone();
  const saveTarget = controls ? controls.target.clone() : new Vector3(0, 1.7, 0);

  const shot = () => {
    renderer.setViewport(0, 0, cW, cH);
    renderer.render(scene, camera);
    return canvas.toDataURL('image/jpeg', 0.92);
  };

  // Vista 1 — prospettica 3/4
  const dist1 = maxDim * 0.9 + 1.8;
  camera.position.set(dist1 * 0.7, dist1 * 0.5, dist1 * 0.85);
  if (controls) controls.target.set(centerX, centerY, centerZ);
  camera.lookAt(centerX, centerY, centerZ);
  camera.updateProjectionMatrix();
  const imgMain = shot();

  // Vista 2 — alzato d'angolo
  const dist2 = maxDim * 0.92 + 1.8;
  camera.position.set((w / 2) + dist2, 1.95, 0);
  if (controls) controls.target.set(0, 1.7, 0);
  camera.lookAt(0, 1.7, 0);
  camera.updateProjectionMatrix();
  const imgCorner = shot();

  // Vista 3 — aerea/pacchetto
  const dist3 = maxDim * 0.7 + 1.5;
  camera.position.set(-w / 2 - dist3 * 0.3, 2.6, -d / 2 - dist3 * 0.45);
  if (controls) controls.target.set(centerX, 1.8, centerZ);
  camera.lookAt(centerX, 1.8, centerZ);
  camera.updateProjectionMatrix();
  const imgPacchetto = shot();

  // ripristino
  renderer.autoClear = prevAuto;
  renderer.setViewport(0, 0, cW, cH);
  camera.position.copy(savePos);
  if (controls) { controls.target.copy(saveTarget); controls.update(); }
  camera.updateProjectionMatrix();
  viewer.requestRender();

  return { imgMain, imgCorner, imgPacchetto };
}
